import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import react_dom from "react-dom";
import TooltipContent from "./TooltipContent.js";
const TooltipPopup = ({ position, isVisible, ...rest }, forwardedRef)=>isVisible ? /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ jsx(TooltipContent, {
        position: position,
        isVisible: isVisible,
        ref: forwardedRef,
        ...rest
    }), document.body) : null;
const Tooltip_TooltipPopup = /*#__PURE__*/ forwardRef(TooltipPopup);
export default Tooltip_TooltipPopup;
